import React from 'react';
import i18n from '../i18n';

export const EmptyDataNode = (val: any) => (
    <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', alignContent: 'center', margin: 10 }}>
        <div style={{ color: val.color ? val.color : '#000', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {val.val || i18n.t('general_text_no_data')}
        </div>
    </div>
);
